import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { ChevronRight } from "lucide-react"

interface ViewAllLinkProps {
  href: string
  text?: string
  /** Hide on mobile only (still visible on desktop) */
  hideOnMobile?: boolean
}

/** Shared "View All" pill button — text link on mobile, bordered pill on desktop. */
export default function ViewAllLink({
  href,
  text = "View All",
  hideOnMobile = false,
}: ViewAllLinkProps) {
  return (
    <LocalizedClientLink
      href={href}
      className={`inline-flex text-xs md:text-sm font-medium transition-colors items-center gap-1 md:gap-2 outline-none focus-visible:ring-2 focus-visible:ring-brand-navy focus-visible:ring-offset-2 uppercase md:normal-case text-brand-primary-blue md:text-brand-navy md:border md:border-brand-navy md:rounded-lg md:px-4 md:py-2 md:hover:bg-gray-50 md:bg-white ${hideOnMobile ? "hidden md:inline-flex" : ""}`}
    >
      {text}
      <ChevronRight className="w-4 h-4" aria-hidden="true" />
    </LocalizedClientLink>
  )
}
